import Component from 'components/pages/HowItWorks/HowItWorks.qmee';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('how-it-works');
export default buildPage(Component, {
  requiresAuthentication: false,
  metaData: {
    title: 'How It Works',
    description: 'How It Works Page',
  },
});
